import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class BankingRoute extends Route {
  @service
  finance;

  afterModel() {
    // Fetch the current "next deposit date" in case we have old data cached.
    // Done in afterModel() as we don't need it in the route's model.
    return this.finance.updateNextDepositDate();
  }
}
